import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KwikstoreVisualEditorModule, EditorsModule, PreviewModule, LayoutEditorService, PreviewEditStoreService } from '@urbannex/kwikstore-visual-editor';
import { AppComponent } from './app.component';
import { NbAccordionModule, NbButtonModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbSidebarService, NbThemeModule, NbThemeService } from '@nebular/theme';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'projects/storeadmin/src/app/@core/core.module';
import { UserData } from 'projects/storeadmin/src/app/@core/data/users';
import { UserService } from 'projects/storeadmin/src/app/@core/mock/users.service';
import { NbAuthModule } from '@nebular/auth';
import { NbSecurityModule } from '@nebular/security';
import { UbsBlogModule } from '@urbannex/blog';
import { ConfigurationModule } from '@urbannex/configuration';
import { environment } from './../environments/environment';
import { Observable } from 'rxjs';
// import { PmsModule } from '@urbannex/pms';

/* export function initializeApp2(appInitService: AppInitConfigService) : ()  => Observable<any> {
  return () => appInitService.Init();
} */

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ConfigurationModule.forRoot({ env: environment }),
    BrowserAnimationsModule,
    PreviewModule,
    KwikstoreVisualEditorModule.forRoot({ previewUrl: environment.previewUrl }),
    NbAuthModule.forRoot(),
    NbButtonModule,
    NbThemeModule.forRoot({ name: 'navy-kadet' }),
    NbMenuModule.forRoot(),
    NbSidebarModule,
    AppRoutingModule,
    NbLayoutModule,
    CoreModule,
    NbAccordionModule,
    NbSidebarModule,
    EditorsModule.forRoot(),
    // UbsBlogModule
    // PmsModule
  ],
  providers: [NbSidebarService, NbThemeService, PreviewEditStoreService, LayoutEditorService, provideAnimations(),
    { provide: UserData, useClass: UserService },
    // { provide:APP_INITIALIZER,useFactory:initializeApp2,deps:[AppInitConfigService],multi:true },
    NbSecurityModule.forRoot({
      accessControl: {
        guest: {
          view: '*',
        },
        user: {
          parent: 'guest',
          create: '*',
          edit: '*',
          remove: '*',
        },
      },
    }).providers],
  bootstrap: [AppComponent]
})
export class AppModule { }
